import React from 'react';
// import PropTypes from 'prop-types';
import styles from './messageSequencer.module.scss';
import checkIcon from './../../../../../globals/images/check_box.svg';

const messageList = ({ id, selectedOption, onClick, text }) => (
    <div className={styles.row}>
        <div className={styles.image}>
            {id === selectedOption ? <img src={checkIcon} alt="checkicon" /> : null}

        </div>
        <div
            onClick={() => { onClick(id); }}
            className={styles['read-text']}>
            {text}
        </div >
    </div>);

messageList.propTypes = {};

messageList.defaultProps = {};

export default messageList;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/messageSequencer/MessageList.js